




import { Vue, Component } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import OrderPreviousDetail from '@/views/contents/shipping/order/OrderPreviousDetail.vue';

@Component({
  components: { AdminIframe, OrderPreviousDetail },
})
export default class OrderPreviousDetailIframe extends Vue {
  private get remoteSrc() {
    const queryObject = { ...this.$route.query, serviceType: 'PRO' };
    const queryString = new URLSearchParams(queryObject).toString();
    const src = process.env.VUE_APP_ADMIN_REMOTE_URL + '/fulfillment/order/previous-detail' + '?' + queryString;

    return src;
  }
}
